import * as React from "react";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

interface props {
  title: string;
}
export const TopoContrato = (param: props) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Typography
        variant="h5"
        fontFamily={"Co Headline Regular"}
        gutterBottom
        align="left"
        marginLeft="15px"
      >
        {t("pages.contracts.titleList")}
      </Typography>
    </React.Fragment>
  );
};
export default TopoContrato;
